import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTankBoot = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 91,
	viewBox: "0 0 100.0 91.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 0.0 11.0 L 0.0 81.0 L 70.0 81.0 L 80.0 91.0 L 100.0 91.0 L 100.0 11.0 Z M 67.0 3.0 L 85.0 3.0 M 67.0 0.0 L 85.0 0.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("rect", {
		x: 70,
		y: 3,
		width: 12,
		height: 8,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgTankBoot;
